import { Component, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsignorContact } from '../../models/sales/sale-consignor.model';
import { ToastService } from '../../shared-new/services/toast.service';
import { SalesService } from 'src/app/services/sales.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { CountryISO, PhoneNumberFormat, SearchCountryField, NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { takeUntil } from 'rxjs/operators';
import { MatTable } from '@angular/material/table';
import { NgForm } from '@angular/forms';
import Constants from 'src/app/constants.json';

@Component({
  selector: 'app-consignor-contact-popup',
  templateUrl: './sale-consignor-contacts-popup.component.html',
  styleUrls: ['./sale-consignor-contacts-popup.component.scss'],
})
export class SaleConsignorContactsPopupComponent extends BaseUnsubscribeComponent {
  @ViewChild('contactForm', { static: false }) contactForm!: NgForm;
  @ViewChild('linkInput') linkInput!: ElementRef;
  @Output() onSave = new EventEmitter<any>();
  @Input() public data: any;
  @ViewChild(MatTable) table!: MatTable<ConsignorContact>;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = Constants.preferredCountries.map((item) => item as CountryISO);

  displayedColumns: string[] = [
    'firstName',
    'lastName',
    'emailAddress',
    'phoneNumber',
    'receiveRepoEmail',
    'receiveRepoSms',
    'action'
  ];

  dataSource: MatTableDataSource<ConsignorContact> = new MatTableDataSource<ConsignorContact>([]);
  isLoader: boolean = false;
  isFormSubmitted: boolean = false;
  consignorName: string = '';
  link: string = '';
  consignorId: number = 0;
  countries: any[] = [];
  copySuccess: boolean = false;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly salesService: SalesService,
    private readonly toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.consignorName = this.data.consignorName;
    this.consignorId = this.data.consignorId;
    this.link = this.data.link;
    this.countries = this.data.countries;
    this.loadConsignorContacts(this.data.consignorId);
  }

  loadConsignorContacts(consignorId: number): void {
    this.isLoader = true;
    this.salesService.getConsignorContacts(consignorId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((contacts: ConsignorContact[]) => {
        this.isLoader = false;

        const formattedContacts = contacts.map(contact => ({
          ...contact,
          selectedCountryISO: contact.phoneNumber != null ? this.setDefaultCountryFromDialCode(contact.countryCode ?? '').trim() : null,
          internationalNumber: contact.phoneNumber != null ? `${contact.phoneNumber}` : null

        }));

        this.dataSource = new MatTableDataSource<ConsignorContact>(formattedContacts);
        setTimeout(() => {
          this.adjustAlignment();

        }, 100);
      });
  }

  private adjustAlignment() {
    $('.iti.iti--allow-dropdown').css('margin-bottom', '0');
  }
  addNewContact() {
    const newContact: ConsignorContact = {
      consignorContactId: 0,
      consignorId: 0,
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: '',
      internationalNumber: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      //selectedCountryISO: null,
      countryCode: '',
      isReceiveRepoEmail: false,
      isReceiveRepoSMS: false
    };
    this.isFormSubmitted = false;
    this.dataSource.data.push(newContact);
    this.table.renderRows();
    this.adjustAlignment();
  }

  removeContact(index: number) {
    const data = this.dataSource.data;
    data.splice(index, 1);
    this.dataSource.data = data;
  }
  private setDefaultCountryFromDialCode(code: string): string {
    var countryCode = '';
    if (code) {
      const dialCode = code.replace('+', '');
      const matched = (window as any).intlTelInputGlobals.getCountryData().find((c: any) => c.dialCode === dialCode);

      if (matched) {
        countryCode = matched.iso2.toUpperCase() as CountryISO;
      }
    }
    return countryCode;
  }
  // Simple country code detection - expand as needed
  /*private getCountryCodeFromPhone(phoneNumber: string): string {
    const matchedCountry = typeof phoneNumber === 'undefined' || phoneNumber === '' ? '' : this.countries.find(country =>
      phoneNumber.startsWith(country.code));

  return matchedCountry?.code ?? ''; // Default
}*/
  public saveConsignorContacts(event?: Event) {
    // Prevent default form submission
    if (event) {
      event.preventDefault();
    }

    //this.isFormSubmitted = true;

    if (this.contactForm?.invalid) {
      // this.toastService.error('Please fill all required fields correctly', 'Validation Error');
      this.scrollToFirstInvalidControl();
      return;
    }

    const contacts: ConsignorContact[] = this.dataSource.data.map(contact => ({
      consignorContactId: contact.consignorContactId,
      consignorId: contact.consignorId,
      firstName: contact.firstName,
      lastName: contact.lastName,
      emailAddress: contact.emailAddress,
      phoneNumber: contact.internationalNumber?.internationalNumber?.replace(contact.internationalNumber?.dialCode, '').trim() ?? "",
      countryCode: contact.internationalNumber?.dialCode,
      isReceiveRepoEmail: contact.isReceiveRepoEmail,
      isReceiveRepoSMS: contact.isReceiveRepoSMS
    }));

    this.isLoader = true;
    this.salesService.saveConsignorContacts(this.consignorId, contacts).subscribe(
      (response) => {
        this.isLoader = false;
        if (response) {
          this.toastService.success('Consignor Contacts Saved', 'Success!');
          this.onSave.emit(response);
        }
      },
      (errorResponse: Error) => {
        this.isLoader = false;
        const errorData = JSON.parse(JSON.stringify(errorResponse));
        if (errorData?.error) {
          this.toastService.error(errorData.error.message || 'An error occurred', "Error");
        }
      }
    );
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement | null = document.querySelector('.ng-invalid');
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }

  async copyLink() {
    try {
      await navigator.clipboard.writeText(this.link);
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      this.fallbackCopyTextToClipboard();
    }
  }

  private fallbackCopyTextToClipboard() {
    const inputElement = this.linkInput.nativeElement as HTMLInputElement;
    inputElement.select();
    inputElement.setSelectionRange(0, 99999);
    try {
      document.execCommand('copy');
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 2000);
    } catch (err) {
      console.error('Fallback copy failed:', err);
      alert('Failed to copy the link. Please copy it manually.');
    } finally {
      inputElement.setSelectionRange(0, 0);
    }
  }
}
